import { useTheme } from "@mui/material";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

/** Sidebar-collapse glyph; forwardRef so MUI Tooltip/ListItemIcon can attach to the svg. */
export const DesktopDrawerCollapseIcon = forwardRef<SVGSVGElement>(function DesktopDrawerCollapseIcon(props, ref) {
    const theme = useTheme();
    const { t } = useTranslation("app");
    return (
        <svg
            ref={ref}
            role="img"
            aria-label={t("sidebar.expand")}
            className="CustomSvgIcon-root"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.833 2.5H4.167C3.25 2.5 2.5 3.25 2.5 4.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667m0 13.333H4.167V4.167h11.666z"
                fill={theme.palette.text.primary}
            />
            <path stroke={theme.palette.text.primary} strokeWidth="1.6" d="M7.8 4v12" />
        </svg>
    );
});
